import React, { useState } from 'react';
import './styles.scss';
import { useMediaQuery } from '@mui/material';
import AccordionMenuBody from './AccordionMenuBody';
import AccordionMenuItem from './AccordionMenuItem';

const AccordionMenu = ({ items = [] }) => {
  const isTabletMobile = useMediaQuery('(max-width:768px)');
  const firstEnabled = items.find(item => !item.disabled) || items[0];
  const [open, setOpen] = useState(firstEnabled);

  return (
    <div className="accordion-menu">
      <div className="accordion-menu__items">
        {items.map(item => (
          <div key={`${item.id}`}>
            <AccordionMenuItem
              key={item.title}
              title={item.title}
              disabled={item.disabled}
              onClick={() => {
                if (item.disabled) {
                  return;
                }
                if (isTabletMobile && item.id === open?.id) {
                  setOpen(null);
                } else {
                  setOpen(item);
                }
              }}
              open={open?.id === item.id}
            />
            {isTabletMobile && open?.id === item.id && <AccordionMenuBody content={open.content} />}
          </div>
        ))}
      </div>
      {!isTabletMobile && open && <AccordionMenuBody key={open.id} content={open.content} />}
    </div>
  );
};

export default AccordionMenu;
